module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp3_8003.58fc2729.png";